export default __webpack_public_path__ + "static/media/money2.058e43ec.jpg";